import { useState } from 'react';
import { passportMeta } from '@/mocks/trace-passport';

export default function PassportHeader() {
  const [copied, setCopied] = useState(false);

  const shareLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  return (
    <header className="sticky top-0 z-40 w-full bg-background-50/95 backdrop-blur-md border-b border-background-200">
      <div className="max-w-[480px] mx-auto w-full px-4 h-14 flex items-center gap-3">
        <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
          <i className="ri-shield-check-line text-lg"></i>
        </span>
        <div className="flex-1 min-w-0">
          <div className="font-heading font-bold text-sm text-foreground-950 truncate">
            {passportMeta.brand}
          </div>
        </div>
        <button
          type="button"
          onClick={shareLink}
          aria-label="复制本页链接"
          className="relative w-9 h-9 flex items-center justify-center rounded-full text-foreground-600 whitespace-nowrap cursor-pointer transition-colors hover:text-secondary-700 hover:bg-background-100"
        >
          <i className={copied ? 'ri-check-line text-lg' : 'ri-share-forward-line text-lg'}></i>
          {copied && (
            <span className="absolute top-11 right-0 px-2.5 py-1 rounded-md bg-foreground-950 text-background-50 text-[11px] whitespace-nowrap">
              链接已复制
            </span>
          )}
        </button>
      </div>
    </header>
  );
}